module.exports = __webpack_public_path__ + "img/bn.82577bde.svg";